import angular from 'angular';

if (!('focus' in angular.element.prototype)) {
  angular.element.prototype.focus = function focus() {
    if (this[0] && angular.isFunction(this[0].focus)) {
      this[0].focus();
    }

    return this;
  };
}
